import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import {conditional} from '../../../util/conditional';
import store from '../../../store';

import {
	selectDatasetnumber,
	selectLdt1,
	selectUlor,
	selectDimensionHeight,
	selectDimensionWidth,
	selectDimensionDepth,
	selectMountingInstruction, selectSpcConfiguration
} from '../../../selectors';

@customElement('avanza-page-data-and-text')
export class AvanzaPageDataAndText extends connect(store)(LitElement) {

	static styles = css`
		.polar {
		  width: 50%;
		}
		.page-container {
			display: flex;
			width: 100%;
			padding-bottom: 4rem;
		}

		.diagrams {
			width: 50%;
			padding-left: var(--specsheet-large-gap);
		}

		.description {
			font: var(	--font-specsheet-light);
			width: 46%;
		}

		.downloads {
			margin-top: 50px;
			font: var(--font-specsheet-bold);
		}

		a {
			color: #000;
		}

		p {
			font: var(--font-specsheet-light);
		}

		p span {
			font: var(--font-specsheet-bold);
		}
		.image {
			margin-bottom: 60px;
		}

		.sketch  {
			height: 230px;
		}

		.title {
			color: var(--color-black);
			font-size: var(--font-size-sections);
			font-weight: bold;
		}

		@media print {
			.page-container {
				display: flex;
				width: 100vw;
				margin-top: 10vw;
			}

			.diagrams {
				width: 50vw;
				padding-left: 0px;
			}

			.description {
				font: var(	--font-specsheet-print-light);
				width: 46vw;
			}

			p {
				font: var(--font-specsheet-print-light);
			}

			p span {
				font: var(--font-specsheet-print-bold);
			}

			.downloads {
				margin-top: 50px;
				font: var(--font-specsheet-print-bold);
			}
		}

	`;
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}
	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}
	render() {
		const s = this.state;
		return html`
			<div class="page-container">
				<div class="diagrams">
					<div class="image">
						${when( this.c('REDTAB.RETURN_LE_PolarDiagramP2') && this.c('REDTAB.RETURN_LE_PolarDiagramP2') !=='', () => html`
							<img alt="polar diagram" src="${this.c('REDTAB.RETURN_LE_PolarDiagramP2')}"/>
						`)}
					</div>

					<div slot="content">
						${when( this.c('REDTAB.RETURN_LU_Sketch') && this.c('REDTAB.RETURN_LU_Sketch') !=='', () => html`
							<img class="sketch" alt="sketch" src="${this.c('REDTAB.RETURN_LU_Sketch')}" />
						`)}
						<p>
						L: ${selectDimensionDepth(s)} mmm, B: ${selectDimensionWidth(s)} mm, H: ${selectDimensionHeight(s)} mm
						</p>
					</div>
				</div>

				<div class="description">
					<div slot="content">
						<trans-label slot="title" key="LE_LuminousFlux_OperatingTime" context="D"></trans-label>
							<div slot="content">
								<shared-llmf-table></shared-llmf-table>
							</div>

							<div slot="content">
								<avanza-tender-text></avanza-tender-text>
							</div>
							<span class="downloads">Downloads</span>
							${when(selectMountingInstruction(this.state) !== null, () => html`
							<a href="${selectMountingInstruction(this.state)}"
							target="_blank">${msg('Mounting instruction')}</a><br>
							`)}
							${when(selectLdt1(this.state) !== null, () => html`
							<a href="${selectLdt1(this.state)}" target="_blank">${msg('LDT Side')} A</a><br>
							`)}

							<p><span>Nehmen Sie gern für einen persönlichen Austausch und weitere Informationen Kontakt mit uns auf.<br><br>
							E info@selux.de<br>
							T +49 30 72 001 0 </span></p>
					</div>
				</div>
			</div>
		`;
	}
}
